export default {
  __MENU_LIST__:[],//目录列表
  __USER_MENU_LIST__:[],//用户权限目录列表
  __TABLE_HEIGHT__:960,//表高度
  __APP_CONFIG__:{},//应用配置
  __APP_LOADING__:{},//全局加载UI
  __PAGE_OPT__:{},//页面参数
  __HOUSE_TREE__:[],
  __HOUSE_TREE_OPEN__:[],
  __HOUSE_TREE_LIST__:[],
  user_permission_ids:[],//权限id数组
  APP_TOKEN:window.localStorage.getItem('token'),
  APP_LOGIN_NAME:window.localStorage.getItem('login'),
  excelTaskCount: 0 // 导出任务计数
}



// WEBPACK FOOTER //
// ./src/store/state.js